import * as React from 'react';
import '@styles/pages/tab1.scss';
import Hour from '@hook/public/hour.tsx';
import { fetch, AreaInfo } from '@/fetch.ts';
import { StageCurrent } from '@/context.ts';
import banner from '@images/banner.png';
import Tab1Rank from '@hook/Tab1/rank.tsx';
import SideBar from '@hook/public/sideBar.tsx';
const { useState, useEffect } = React;

const Tab1: React.FC<void> = () => {
  const [list, List] = useState<AreaInfo[]>([]);
  useEffect(() => {
    /* 获取所有分区 */
    fetch.getAreaConfig(
      {
        iMatchId: 1,
      },
    )
      .then(rsp => {
        List(rsp.vAreaList.value);
      })
  }, [])
  return (
    <StageCurrent.Provider
      value={{current: 1}}
    >
      <div className='tab1'>
        <SideBar list={list} showHour={true} />
        <Hour />
        <section className='ranklist'>
          {
            list.map((item: AreaInfo) => (
              <Tab1Rank key={1 + item.iArea + 1} {...item} revive={false} haixuan={false} />
            ))
          }
        </section>
      </div>
    </StageCurrent.Provider>
  );
}

export default Tab1;